export default __webpack_public_path__ + "static/media/renard3.c372ab8c.png";